import { setPreference } from '@fs/zion-preferences'
import { Button, Checkbox, DialogOverlay, DialogOverlayFooter, DialogOverlayActions } from '@fs/zion-ui'
import React from 'react'
import transl from './GroupDataHeader.transl'

export const disclaimerPreferenceName = 'lightyear.record-metadata-review-disclaimer'
export default function RecordMetadataReviewInstructionsOverlay({ overlay, setShowReviewInstructions }) {
  const [hideDisclaimer, setHideDisclaimer] = React.useState()

  return (
    <DialogOverlay {...overlay} title={transl.recordMetadataReviewModalTitle()}>
      {transl.recordMetadataReviewDialogBody()}
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Checkbox
            label={transl.recordMetadataReviewDialogDoNotShowAgainCheckboxLabel()}
            checked={hideDisclaimer}
            onChange={({ target: { checked } }) => {
              setHideDisclaimer(checked)
              setPreference(disclaimerPreferenceName, checked)
            }}
            name="recordMetadataReviewDialogDoNotShowAgainCheckboxLabel"
          />
          <Button
            onClick={() => {
              // do not show the dialog again during this page load
              setShowReviewInstructions(false)
              overlay.close()
            }}
            emphasis="high"
          >
            {transl.okayButton()}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
